export default __webpack_public_path__ + "static/media/restrict_icon.72837880.svg";